import lazyWithReload from 'config/ChunkReload';
import { menuBuilder } from 'services/Routes.service';
import { WorldIcon } from '@edusynch/edusynch-svg-icons';

const CountryPermissionsContainer = lazyWithReload(() =>
  import('modules/CountryPermissions/CountryPermissions.container')
);

const CountryPermissionsMenu = menuBuilder([
  {
    Icon: WorldIcon,
    name: 'Country Permissions',
    component: CountryPermissionsContainer,
    ability: 'country_permissions',
  },
]).addSubmenu();

export default CountryPermissionsMenu;
